






import Vue from "vue";
import _ from "lodash";

// Vuex
import { RootState } from "@/store";
import { mapMutations, mapState } from "vuex";
import * as m from "@/store/modules/LicenseModule/mutations";

// Model
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { Installation } from "@/model/data/Installation";

export default Vue.extend({
    data() {
        return {
            currentSelection: false,
        };
    },
    props: {
        // value: {},
        installationName: { type: String, required: true },
        module: { type: Number, required: true },
        disabled: { type: Boolean, required: true },
    },
    computed: {
        ...mapState({
            installations: (state: RootState) => state.license.installations,
            localInstallations: (state: RootState) => state.license.localInstallations,
        }),

        computedEnabled: {
            get: function () {
                if (this.localInstallations.filter((i: Installation) => i.name == this.installationName).length > 0) {
                    let currentInstallation: Installation = this.localInstallations.filter((i: Installation) => i.name == this.installationName)[0];
                    return LicenseModuleEnum[currentInstallation.licenseData.enabledModules & this.module] == LicenseModuleEnum[this.module];
                } else return false;
            },
            set: function (newValue) {
                let newLocalInstallations = _.cloneDeep(this.localInstallations);

                if (newValue) {
                    if (this.availableLicenses > 0) {
                        this[m.ADD_LICENSE_LOCALLY](this.module);
                        newLocalInstallations.filter((i: Installation) => i.name == this.installationName)[0].licenseData.enabledModules =
                            newLocalInstallations.filter((i: Installation) => i.name == this.installationName)[0].licenseData.enabledModules + this.module;
                        this[m.SET_LOCAL_INSTALLATIONS](newLocalInstallations);
                    }
                } else {
                    this[m.REMOVE_LICENSE_LOCALLY](this.module);
                    newLocalInstallations.filter((i: Installation) => i.name == this.installationName)[0].licenseData.enabledModules =
                        newLocalInstallations.filter((i: Installation) => i.name == this.installationName)[0].licenseData.enabledModules - this.module;
                    this[m.SET_LOCAL_INSTALLATIONS](newLocalInstallations);
                }
            },
        },

        availableLicenses() {
            return this.$store.getters.getAvailableLicenses(this.module);
        },

        serverValue() {
            if (this.installations && this.installations.length > 0) {
                let currentServerInstallation: Installation = this.installations.filter((i: Installation) => i.name == this.installationName)[0];
                return LicenseModuleEnum[currentServerInstallation.licenseData.enabledModules & this.module] == LicenseModuleEnum[this.module];
            }
            return false;
        },

        noLicenseAvailable() {
            if (this.serverValue != this.computedEnabled) return false;
            return this.availableLicenses <= 0;
        },
    },
    methods: {
        ...mapMutations([m.ADD_LICENSE_LOCALLY, m.REMOVE_LICENSE_LOCALLY, m.SET_LOCAL_INSTALLATIONS]),
    },
});
